import styled from 'styled-components'
import { themeObject, textModels } from 'Pages/landings/newLandings/common/style'

export const Title = styled.p`
	${textModels('heading', 'h2', '600')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
	margin-bottom: 24px;
`
export const Subtitle = styled.p`
	${textModels('text', 'l', '400')}
	color: ${themeObject.colors.grey[800]};
	margin-bottom: 16px;
`
export const Footnote = styled.p`
	${textModels('notAdaptive', 's', '400')}
	color: ${themeObject.colors.grey[600]};
`
export const Text = styled.p`
	${textModels('text', 'l', '400')}
	color: ${themeObject.colors.grey[800]};
	text-align: left;
`
export const TextSemibold = styled.span`
	${textModels('text', 'l', '600')}
`
